import React from "react";
import Slider from "react-slick/lib/slider";
import {
  heroEvent1,
  heroEvent2,
  heroEvent3,
  heroEvent4,
  heroEvent5,
  heroEvent6,
  heroEvent7,
  heroEvent8,
  heroEvent9,
  heroEvent10,
  heroEvent11,
  heroEvent12,
  heroEvent13,
} from "../../../../assets/images/index";
const HeroEventSlider = () => {
  const sliderImages1 = [
    heroEvent1,
    heroEvent2,
    heroEvent3,
    heroEvent4,
    heroEvent5,
    heroEvent6,
    heroEvent7,
    heroEvent8,
    heroEvent9,
    heroEvent10,
    heroEvent11,
    heroEvent12,
    heroEvent13,
  ];
  const settings1 = {
    dots: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 1000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  };
  return (
    <div>
      {" "}
      <Slider {...settings1}>
        {sliderImages1?.map((image, index) => (
          <div key={`${image?._id} ${index}`} className="border-0">
            <img
              loading="lazy"
              className="img-fluid h-100 w-100 card-img-top"
              
              src={image}
              alt={image?.alt || "atalimg"}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HeroEventSlider;
